import React, { useState, useEffect } from 'react';

const ConsoleLogger = () => {
  const [logs, setLogs] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const originalLog = console.log;
    const originalError = console.error;
    const originalWarn = console.warn;

    console.log = (...args) => {
      setLogs(prev => [...prev, { type: 'log', content: args.join(' ') }]);
      originalLog.apply(console, args);
    };

    console.error = (...args) => {
      setLogs(prev => [...prev, { type: 'error', content: args.join(' ') }]);
      originalError.apply(console, args);
    };

    console.warn = (...args) => {
      setLogs(prev => [...prev, { type: 'warn', content: args.join(' ') }]);
      originalWarn.apply(console, args);
    };

    // Test log message
    console.log("ConsoleLogger initialized");

    return () => {
      console.log = originalLog;
      console.error = originalError;
      console.warn = originalWarn;
    };
  }, []);

  return (
    <div style={{
      position: 'fixed',
      top: '20px',
      right: '20px',
      width: '300px',
      maxHeight: isCollapsed ? '30px' : 'calc(100vh - 40px)',
      overflowY: 'auto',
      backgroundColor: '#f0f0f0',
      border: '1px solid #ccc',
      borderRadius: '5px',
      padding: '10px',
      transition: 'max-height 0.3s ease-in-out',
      zIndex: 1000
    }}>
      <h3 style={{ margin: '0 0 10px 0', cursor: 'pointer' }} onClick={() => setIsCollapsed(!isCollapsed)}>
        Console Output {isCollapsed ? '▼' : '▲'}
      </h3>
      {!isCollapsed && (
        <div style={{ maxHeight: 'calc(100vh - 80px)', overflowY: 'auto' }}>
          {logs.length > 0 ? (
            logs.map((log, index) => (
              <div key={index} style={{ 
                color: log.type === 'error' ? 'red' : log.type === 'warn' ? 'orange' : 'black',
                marginBottom: '5px',
                wordWrap: 'break-word'
              }}>
                {log.content}
              </div>
            ))
          ) : (
            <div>No logs yet.</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ConsoleLogger;